import { useEffect, useRef } from "react"
import { useAudio } from "@/app/store"
import { effectList } from "@/app/store/useAudio"

type Props = {
    children: any
    onClick?: Function
    className?: string
    disabled?: boolean
    sound?: keyof typeof effectList | 'deer'
}

export const ScrollToTop = () => (
    <Button
        className="btn-main mt-4 w-full"
        onClick={() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
            document.body.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
        }}
        sound="return"
    >回到最上方</Button>
)

export default function Button(props: Props) {

    const { children, onClick, className, disabled, sound = 'button' } = props
    const audio = useAudio()
    const clickTimeout = useRef<ReturnType <typeof setTimeout> | null>(null)

    useEffect(() => {
        return (() => {
            clearTimeout(clickTimeout.current)
        })
    }, [])

    function handleOnClick() {
        if (onClick) {
            onClick()
        }
        if (sound === 'deer') {
            audio.playDeer()
        }
        else {
            audio.playSFX(sound)
        }
    }

    return (
        <>
        <button
            className={className}
            onClick={handleOnClick}
            disabled={disabled}
        >   
            {children}
        </button>
        </>
    )
}